import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.trackEvent([
            'Tarot Reading Upsell',
            `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
            `Repeat: ${this.props.upc}`,
        ]);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.upsells != this.props.upsells) {
            return true;
        }

        return false;
    }

    render({ upc, url, upsells }) {
        return (
            <tarot-report-button upc={upc} url={url}>
                <a
                    className={`button-warning ${upsells ? 'is-block-mobile' : '' }`}
                    href={url}
                    onClick={this.handleClick}
                >
                    REPEAT <span className='is-hidden-mobile'>THIS</span>
                    <span className='is-hidden-mobile'> </span>
                    <br className='is-visible-mobile' />
                    READING
                </a>
            </tarot-report-button>
        );
    }

    handleClick = (e) => {
        e.preventDefault();

        this.props.trackPromo([
            'Tarot Reading Upsell',
            `Repeat: ${this.props.upc}`,
        ]);

        this.props.trackEvent([
            'Tarot Reading Upsell',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            `Repeat: ${this.props.upc}`,
        ]);

        document.location = this.props.url;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    upsells: state.product && state.product.upsells,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (action) => dispatch({ type: 'ga:event', payload: action }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
